export const viewerApiUrl = {
  task: "/viewer/task",
  project: "/viewer/project",
};
